// en, de, fr, pt
export default {
  en: {
    Terminals: 'Terminals',
    Dashboard: 'Dashboard',
    eCommerce: 'eCommerce',
    Apps: 'Apps',
    Todo: 'Todo',
    Chat: 'Chat',
    Email: 'Email',
    Calendar: 'Calendar',
    FullCalendar: 'Full Calendar',
    SimpleCalendar: 'Simple Calendar',
    Authentication: 'Authentication',

    Register: 'Register',
    ForgotPassword: 'Forgot Password',
    ResetPassword: 'Reset Password',
    LockScreen: 'Lock Screen',

    Error: 'Error',
    404: '404',
    500: '500',
    NotAuthorized: 'Not Authorized',
    Maintenance: 'Maintenance',


    Support: 'Support',
    Documentation: 'Documentation',
    RaiseSupport: 'Raise Support',
    demoTitle: 'Card Title',
    demoText: 'Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.'
  },
  az: {
    Dashboard: 'Əsas səhifə',
    Municipalities: 'Bələdiyyələr',
    Statistics: 'Statistika',
    groupPaymentStatistics: 'Qrup ödəniş statistikası',
    detailsPaymentStatistics: 'Ətraflı ödəniş statistikası',
    Terminals: 'Terminallar',
    Apps: 'Keçidlər',
    Pay: 'Ödəniş et',
    Payments: 'Ödənişlər',
    DuplicateInvoice: 'Çek dublikatının çapı'

  }
}
